import FieldDefs from './TopPagesFieldDefs.js'
import {doLangFields} from '../../lib/ks-tools'

export default {
    template: `<div><slot v-bind="self" /></div>`,
    data () {
        return {
            fields: doLangFields(this, "lang.report.backlinks_toppages.fields", FieldDefs),
            sortOrder: [
                {
                    field: 'numurl',
                    direction: 'desc'
                }
            ],
            additionalActions: [],
        }
    },
    computed: {
        self() {
            return this;
        },
    }
}
